<template>
  <div class="inventoryInquiry">
    <div class="filter">
      <div class="filter_item">
        <el-input
          class="filter_item_input"
          v-model="form.zsm"
          placeholder="追溯码"
          prefix-icon="el-icon-search"
          clearable>
        </el-input>
      </div>
      <div class="filter_item">
        <el-select
          class="filter_item_input"
          v-model="form.artNo"
          placeholder="药品名称/药品货号"
          filterable
          remote
          :remote-method="drugRemote"
          clearable
          :loading="drugMap.loading">
          <el-option
            v-for="item in drugMap.list"
            :key="item.artNo"
            :label="item.drugName"
            :value="item.artNo">
            <div class="drug_option">
              <span class="drug_option_left">{{ item.artNo }}</span>
              <span class="drug_option_right">{{ item.drugName }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="filter_action">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </div>

    <div v-if="drugInfo.drugName" class="drug_info">
      <div class="drug_info_item">商品名称：{{ drugInfo.drugName || '-' }}</div>
      <div class="drug_info_item">货号：{{ drugInfo.artNo || '-' }}</div>
      <div class="drug_info_item">规格：{{ drugInfo.spec || '-' }}</div>
      <div class="drug_info_item">厂家：{{ drugInfo.manufacturer || '-' }}</div>
    </div>

    <div class="code_list">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column prop="zsm" label="追溯码">
          <template slot-scope="scope">
            <div class="code_list_code" @click="viewCode(scope.row.zsm)">{{ scope.row.zsm }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="zsmStatus" label="状态">
          <template slot-scope="scope">
            <span>{{ codeStatusMap[scope.row.zsmStatus] && codeStatusMap[scope.row.zsmStatus].name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="batchNo" label="批号"></el-table-column>
        <el-table-column prop="expireTime" label="效期">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.expireTime).Format('yyyy-MM-dd') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="storeNo" label="入库单号">
          <template slot-scope="scope">
            <span>{{ scope.row.storeNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="storeTime" label="入库时间"></el-table-column>
      </el-table>
    </div>

    <div class="code_pagination">
      <el-pagination
        :current-page="form.pageNo"
        :page-size="form.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="listPageNoChange">
      </el-pagination>
    </div>

    <el-dialog
      title="追溯码全链路"
      class="code_dialog"
      :visible.sync="codeMap.visible"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="code_content">
        <div class="code_basic">
          <div class="code_basic_header">
            <div class="code_basic_header_code">追溯码：{{ codeMap.basic.zsm }}</div>
            <div :class="`code_basic_header_status ${codeStatusMap[codeMap.basic.zsmStatus] && codeStatusMap[codeMap.basic.zsmStatus].class}`">{{ codeStatusMap[codeMap.basic.zsmStatus] && codeStatusMap[codeMap.basic.zsmStatus].name }}</div>
          </div>
          <div class="code_basic_introduction">
            <div class="code_basic_introduction_row">归属商品：{{ codeMap.basic.drugName }}</div>
            <div class="code_basic_introduction_row">归属货号：{{ codeMap.basic.artNo }}</div>
            <div class="code_basic_introduction_row">归属批号：{{ codeMap.basic.batchNo }}</div>
          </div>
        </div>
        <div class="code_record">
          <div class="code_record_title">流转时间线</div>
          <div class="code_record_list">
            <div v-for="(record, recordIndex) in codeMap.logList" class="code_record_item">
              <div class="record_axis">
                <div class="record_axis_node">
                  <div class="record_axis_node_out">
                    <div :class="{ 'record_axis_node_in': true, 'warehousing': record.opType === 'STORE' || record.opType === 'REFUND', 'outbound': record.opType === 'SALE' }"></div>
                  </div>
                </div>
                <div v-if="recordIndex < (codeMap.logList.length - 1)" class="record_axis_line"></div>
              </div>
              <div class="record_info">
                <div class="record_info_node">
                  <div :class="{ 'record_info_status': true, 'warehousing': record.opType === 'STORE' || record.opType === 'REFUND', 'outbound': record.opType === 'SALE' }">{{ record.opType === 'STORE' || record.opType === 'REFUND' ? '进' : '出' }}</div>
                  <div class="record_info_name">
                    <template v-if="record.opType === 'STORE'">入库</template>
                    <template v-if="record.opType === 'REFUND'">销售退货</template>
                    <template v-if="record.opType === 'SALE'">销售出库</template>
                  </div>
                </div>
                <div class="record_info_introduction">
                  <div v-if="record.opType === 'SALE'" class="record_info_introduction_row">收费单号：{{ record.billNo }}</div>
                  <div v-if="record.opType === 'REFUND'" class="record_info_introduction_row">退费单号：{{ record.billNo }}</div>
                  <div class="record_info_introduction_row">操作人：{{ record.opUser }}</div>
                  <div class="record_info_introduction_row">操作时间：{{ record.opTime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="异常提示"
      class="prompt_dialog"
      :visible.sync="promptMap.visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="prompt_content">
        <div class="prompt_info_main">该追溯码归属门店为：{{ promptMap.deptName }}</div>
        <div class="prompt_info_code">
          <div class="prompt_info_code_text">追溯码：{{ promptMap.zsm }}</div>
          <div class="prompt_info_code_btn" @click="copyCode">复制</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'inventoryInquiry',
    data() {
      return {
        codeStatusMap: {
          'STORE': { name: '在库', class: 'inStock' },
          'REFUND': { name: '在库', class: 'inStock' },
          'SALE': { name: '已销售', class: 'sales' },
          'UNKNOWN': { name: '未知', class: '' }
        },
        drugMap: {
          loading: false,
          list: []
        },
        listLoading: false,
        form: {
          zsm: '',
          artNo: '',
          pageNo: 1,
          pageSize: 10
        },
        drugInfo: {
          drugName: '',
          artNo: '',
          spec: '',
          manufacturer: ''
        },
        list: [],
        total: 0,
        promptMap: {
          visible: false,
          deptName: '',
          zsm: ''
        },
        codeMap: {
          visible: false,
          basic: {
            zsm: '',
            zsmStatus: '',
            drugName: '',
            artNo: '',
            batchNo: ''
          },
          logList: []
        }
      }
    },
    methods: {
      async drugRemote (query) {
        if ([null, undefined, ''].includes(query)) {
          this.drugMap.list = []
          return
        }
        this.drugMap.loading = true
        const res = await req.get('/system/use/queryDrugInfo', {
          deptId: sessionStorage.getItem('deptId'),
          searchWhere: query,
          pageNo: 1,
          pageSize: 20
        })
        this.drugMap.loading = false
        if (res.code === 200) {
          this.drugMap.list = res.data.list
        }
      },
      async getList () {
        if ([null, undefined, ''].includes(this.form.zsm) && [null, undefined, ''].includes(this.form.artNo)) {
          this.drugInfo.drugName = ''
          this.drugInfo.artNo = ''
          this.drugInfo.spec = ''
          this.drugInfo.manufacturer = ''

          this.list = []
          this.total = 0
          return
        }
        this.listLoading = true
        const res = await req.post('/system/use/qeruyDrugZsm', {
          deptId: sessionStorage.getItem('deptId'),
          zsm: this.form.zsm,
          artNo: this.form.artNo,
          pageNum: this.form.pageNo,
          pageSize: this.form.pageSize
        })
        this.listLoading = false
        if (res.code === 200) {
          if (res.data.success) {
            this.list = res.data.records
            this.total = res.data.total

            if (this.form.pageNo === 1 && this.list.length > 0) {
              this.drugInfo.drugName = this.list[0].drugName
              this.drugInfo.artNo = this.list[0].artNo
              this.drugInfo.spec = this.list[0].specification
              this.drugInfo.manufacturer = this.list[0].manufacturer
            }
          } else {
            this.list = []
            this.total = 0
            
            this.promptMap.deptName = res.data.deptName
            this.promptMap.zsm = this.form.zsm
            this.promptMap.visible = true
          }
        }
      },
      listPageNoChange (pageNo) {
        this.form.pageNo = pageNo
        this.getList()
      },
      search () {
        this.form.pageNo = 1
        this.getList()
      },
      reset () {
        this.form = {
          zsm: '',
          artNo: '',
          pageNo: 1,
          pageSize: 20
        }
        this.drugMap.list = []
        this.drugInfo = {
          drugName: '',
          artNo: '',
          spec: '',
          manufacturer: ''
        }
        this.list = []
        this.total = 0
      },
      async viewCode (zsm) {
        const res = await req.post('/system/use/queryZsmLog', {
          deptId: sessionStorage.getItem('deptId'),
          zsm: zsm
        })
        if (res.code === 200) {
          this.codeMap.basic.zsm = res.data.zsm
          this.codeMap.basic.zsmStatus = res.data.curZsmStatus
          this.codeMap.basic.drugName = res.data.drugName
          this.codeMap.basic.artNo = res.data.rtNo
          this.codeMap.basic.batchNo = res.data.batchNo
          this.codeMap.logList = res.data.operationLogs
          this.codeMap.visible = true
        }
      },
      async copyCode () {
        try {
          await navigator.clipboard.writeText(this.promptMap.zsm);
          this.$message.success('复制成功')
        } catch (err) {
          this.$message.error('复制失败')
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .inventoryInquiry {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  .filter_item {
    width: 220px;
  }

  .filter_item_input {
    width: 100%;
  }

  .drug_option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 220px;
  }

  .drug_option_left {
    flex-shrink: 0;
    width: 60px;
  }

  .drug_option_right {
    flex-grow: 1;
    margin: 0 0 0 12px;
    min-width: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .drug_info {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    margin: 12px 0 0 0;
    padding: 12px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
  }

  .drug_info_item {
    font-size: 14px;
    color: #666666;
  }

  .code_list {
    width: 100%;
  }

  .filter + .code_list {
    margin: 12px 0 0 0;
  }

  .code_list_code {
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;
  }

  .code_pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .code_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .code_content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .code_basic {
    box-sizing: border-box;
    padding: 12px;
    width: 100%;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
  }

  .code_basic_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .code_basic_header_code {
    line-height: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .code_basic_header_status {
    line-height: 24px;
    font-size: 16px;
  }

  .code_basic_header_status.inStock {
    color: #347EFF;
  }

  .code_basic_header_status.sales {
    color: #FE8F1F;
  }

  .code_basic_introduction {
    margin: 8px 0 0 0;
    width: 100%;
  }

  .code_basic_introduction_row {
    line-height: 22px;
    font-size: 14px;
    color: #9A9A9A;
  }

  .code_record {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .code_record_title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .code_record_list {
    margin: 12px 0 0 0;
    width: 100%;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .code_record_item {
    display: grid;
    grid-template-columns: 14px 1fr;
    column-gap: 10px;
    width: 100%;
  }

  .record_axis {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .record_axis_node {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 24px;
  }

  .record_axis_node_out {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 14px;
    height: 14px;
    background-color: #FFFFFF;
    border-radius: 50%;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  }

  .record_axis_node_in {
    width: 7px;
    height: 7px;
    border-radius: 50%;
  }

  .record_axis_node_in.warehousing {
    background-color: #177BF0;
  }

  .record_axis_node_in.outbound {
    background-color: #FE8F1F;
  }

  .record_axis_line {
    flex-grow: 1;
    width: 1px;
    border-left: 1px dashed #D0D0D0;
  }

  .record_info {
    width: 100%;
  }

  .record_info_node {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .record_info_status {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 24px;
    font-weight: 600;
    font-size: 14px;
    border-radius: 2px;
  }

  .record_info_status.warehousing {
    color: #177BF0;
    background-color: #E4F5FF;
  }

  .record_info_status.outbound {
    color: #FE8F1F;
    background-color: #FFEAD5;
  }

  .record_info_name {
    margin: 0 0 0 4px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
  }

  .record_info_introduction {
    padding: 6px 0 16px 0;
    width: 100%;
  }

  .record_info_introduction_row {
    line-height: 20px;
    font-size: 14px;
    color: #9A9A9A;
  }
  
  .prompt_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .prompt_content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .prompt_info_main {
    line-height: 32px;
    font-size: 16px;
    color: #F56C6C;
  }

  .prompt_info_code {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .prompt_info_code_text {
    line-height: 32px;
    font-size: 16px;
    color: #666666;
  }

  .prompt_info_code_btn {
    margin: 0 0 0 6px;
    padding: 0px;
    font-size: 16px;
    color: #409EFF;
    border: none;
    cursor: pointer;
  }

</style>
